export const fromInputDefaultAirports = [
  {
    code: "ASB",
    countryCode: "TM",
    countryName: {
      ru: "Туркменистан",
      en: "Turkmenistan",
      uz: "Turkmaniston",
      tm: "Türkmenistan",
    },
    name: {
      ru: "Ашхабад",
      en: "Ashgabat",
      uz: "Ashgabat",
      tm: "Aşgabat",
    },
    isMain: true,
  },
  {
    code: "IST",
    countryCode: "TR",
    countryName: {
      ru: "Турция",
      en: "Turkey",
      uz: "Turkiya",
      tm: "Türkiýe",
    },
    name: {
      ru: "Стамбул",
      en: "Istanbul",
      uz: "Istanbul",
      tm: "Stambul",
    },
    isMain: true,
  },
  {
    code: "MOW",
    countryCode: "RU",
    countryName: {
      ru: "Россия",
      en: "Russia",
      uz: "Rossiya",
      tm: "Russiýa",
    },
    name: {
      ru: "Москва",
      en: "Moscow",
      uz: "Moskva",
      tm: "Moskwa",
    },
    isMain: true,
  },
  {
    code: "KRW",
    countryCode: "TM",
    countryName: {
      ru: "Туркменистан",
      en: "Turkmenistan",
      uz: "Turkmaniston",
      tm: "Türkmenistan",
    },
    name: {
      ru: "Туркменбаши",
      en: "Turkmenbashy",
      uz: "Turkmanboshi",
      tm: "Türkmenbaşy",
    },
    isMain: true,
  },
  {
    code: "DXB",
    countryCode: "AE",
    countryName: {
      ru: "Объединенные Арабские Эмираты",
      en: "United Arab Emirates",
      uz: "Birlashgan Arab Amirliklari",
      tm: "Birleşen Arap Emirlikleri",
    },
    name: {
      ru: "Дубай",
      en: "Dubai",
      uz: "Dubay",
      tm: "Dubaý",
    },
    isMain: true,
  },
  {
    code: "TAS",
    countryCode: "UZ",
    countryName: {
      ru: "Республика Узбекистан",
      en: "Uzbekistan",
      uz: "O'zbekiston",
      tm: "Özbegistan Respublikasy",
    },
    name: {
      ru: "Ташкент",
      en: "Tashkent",
      uz: "Toshkent",
      tm: "Daşkent",
    },
    isMain: true,
  },
  {
    code: "BHK",
    countryCode: "UZ",
    countryName: {
      ru: "Республика Узбекистан",
      en: "Uzbekistan",
      uz: "O'zbekiston",
      tm: "Özbegistan Respublikasy",
    },
    name: {
      ru: "Бухара",
      en: "Bukhara",
      uz: "Buxoro",
      tm: "Buhara",
    },
    isMain: true,
  },
];

export const toInputDefaultAirports = [
  {
    code: "MOW",
    countryCode: "RU",
    countryName: {
      ru: "Россия",
      en: "Russia",
      uz: "Rossiya",
      tm: "Russiýa",
    },
    name: {
      ru: "Москва",
      en: "Moscow",
      uz: "Moskva",
      tm: "Moskwa",
    },
    isMain: true,
  },
  {
    code: "IST",
    countryCode: "TR",
    countryName: {
      ru: "Турция",
      en: "Turkey",
      uz: "Turkiya",
      tm: "Türkiýe",
    },
    name: {
      ru: "Стамбул",
      en: "Istanbul",
      uz: "Istanbul",
      tm: "Stambul",
    },
    isMain: true,
  },
  {
    code: "DXB",
    countryCode: "AE",
    countryName: {
      ru: "Объединенные Арабские Эмираты",
      en: "United Arab Emirates",
      uz: "Birlashgan Arab Amirliklari",
      tm: "Birleşen Arap Emirlikleri",
    },
    name: {
      ru: "Дубай",
      en: "Dubai",
      uz: "Dubay",
      tm: "Dubaý",
    },
    isMain: true,
  },
  {
    code: "MSQ",
    countryCode: "BY",
    countryName: {
      ru: "Беларусь",
      en: "Belarus",
      uz: "Belarus",
      tm: "Belarus",
    },
    name: {
      ru: "Минск",
      en: "Minsk",
      uz: "Minsk",
      tm: "Minsk",
    },
    isMain: true,
  },
  {
    code: "URC",
    countryCode: "CN",
    countryName: {
      ru: "Китай",
      en: "China",
      uz: "Xitoy",
      tm: "Hytaý",
    },
    name: {
      ru: "Урумчи",
      en: "Urumqi",
      uz: "Urumchi",
      tm: "Urumçi",
    },
    isMain: true,
  },
  {
    code: "TAS",
    countryCode: "UZ",
    countryName: {
      ru: "Республика Узбекистан",
      en: "Uzbekistan",
      uz: "O'zbekiston",
      tm: "Özbegistan Respublikasy",
    },
    name: {
      ru: "Ташкент",
      en: "Tashkent",
      uz: "Toshkent",
      tm: "Daşkent",
    },
    isMain: true,
  },
];
